import React, { Component } from 'react';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import Login from './components/login/Login';
import Overview from './components/overview/Overview';
import Vignets from './components/vignets/Vignets';
import VignetDetail from './components/vignets/Detail';
import Graphics from './components/gallery/Graphics';
import Audio from './components/gallery/Audio';
import Video from './components/gallery/Video';
import Playlist from './components/playlist/index';
import Lvignets from './components/playlist/ListVignets';
import PlaylistDetail from './components/playlist/Detail';
import User from './components/user/User';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom'



const store = configureStore();

class App extends Component {
  render() {
    return (
        <Provider store={store}>
            <Router>
                <div className="App">

                        <Route exact path='/' component={Login} />
                        <Route exact path='/login' component={Login} />
                        <Route exact path="/overview" component={Overview} />
                        <Route exact path="/vignets" component={Vignets} />
                        <Route exact path="/playlist/add/:id" component={Vignets} />
                        <Route exact path="/vignet/:id" component={VignetDetail} />
                        <Route exact path="/gallery" component={Graphics} />
                        <Route exact path="/audio" component={Audio} />
                        <Route exact path="/video" component={Video} />
                        <Route exact path="/playlists" component={Playlist} />
                        <Route exact path="/playlist/:id" component={PlaylistDetail} />
                        <Route exact path="/view-playlist/:id" component={Lvignets} />
                        <Route exact path="/users" component={User} />

                </div>
            </Router>
        </Provider>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js